// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"index_pageTitle_3gT9C","cardTitle":"index_cardTitle_2svep","filledBtn":"index_filledBtn_3OwJC","requiredMark":"index_requiredMark_1DDHU","stripe0":"index_stripe0_zv_sV","stripe1":"index_stripe1_gBPbd","stripe":"index_stripe_3k250","description":"index_description_23iGa","item":"index_item_2ClJE","itemLabel":"index_itemLabel_1Leij"};
    if(module.hot) {
      // 1788760852259
      var cssReload = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"","locals":true});
      module.hot.dispose(cssReload);
      
    }
  